import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-calc-settings-dialog',
  standalone: false,
  template: `
    <div class="p-7 max-w-[90vw]">
      <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-2">Calculation Settings</p>

      <div class="mt-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Starting Year</label>
        <mat-form-field class="w-full" appearance="outline">
          <input matInput type="number" [(ngModel)]="startingYear">
        </mat-form-field>
      </div>

      <div class="flex justify-end gap-3 mt-4">
        <button (click)="dialogRef.close()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
        <button (click)="dialogRef.close(startingYear)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Confirm</button>
      </div>
    </div>
  `
})
export class CalcSettingsDialogComponent {
  startingYear: number;

  constructor(
    public dialogRef: MatDialogRef<CalcSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { startingYear: number }
  ) {
    this.startingYear = data?.startingYear ?? new Date().getFullYear();
  }
}
